import angular from 'angular';
import leadsToApplicationModal from './leadsToApplicationModal';
import './style.scss';

export default angular
  .module('components.leadsToApplicationModal', [])
  .component('leadsToApplicationModal', leadsToApplicationModal).name;
